import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";

import { env } from "./env";

export const envName = env.envName;
export const isProd = env.isProd;

export const timelineFeatures: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: false,
    isOzmoIFrameEnabled: false,
    isProactiveEnabled: false,
    isReactiveCallContextV2Enabled: false,
    isSalesFAQEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
